/* ==========================================================================
   PASIÓN PICKLEBALL — scripts propios (vanilla, sin librerías)
   Cada init comprueba si su elemento existe, así el archivo sirve para
   todas las páginas.
   ========================================================================== */
function ppT(k, d) { return (window.PP_T && window.PP_T[k]) || d; }

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Animaciones de entrada ---------- */
  function initReveals() {
    var elementos = document.querySelectorAll('.pp-reveal');
    if (!elementos.length) return;

    function mostrarTodo() {
      elementos.forEach(function (el) { el.classList.add('pp-visible'); });
    }

    if (reduceMotion) { mostrarTodo(); return; }

    // Se usa un escucha de scroll en vez de IntersectionObserver. El observador
    // no llega a dispararse en algunos navegadores integrados (Instagram,
    // Facebook, TikTok), y ahí media página se quedaría invisible.
    var pendientes = Array.prototype.slice.call(elementos);
    var pedido = false;

    function revisar() {
      pedido = false;
      var alto = window.innerHeight;
      pendientes = pendientes.filter(function (el) {
        var caja = el.getBoundingClientRect();
        var dentro = caja.top < alto * 0.92 && caja.bottom > 0;
        if (dentro) { el.classList.add('pp-visible'); return false; }
        return true;
      });
      if (!pendientes.length) {
        window.removeEventListener('scroll', alHacerScroll);
        window.removeEventListener('resize', alHacerScroll);
      }
    }

    function alHacerScroll() {
      if (pedido) return;
      pedido = true;
      window.requestAnimationFrame(revisar);
    }

    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    revisar();

    // Red de seguridad: pase lo que pase, a los 3 segundos todo es visible.
    // Nunca se deja contenido oculto dependiendo de que un evento llegue.
    setTimeout(mostrarTodo, 3000);
  }

  /* ---------- Acordeón FAQ / detalles de producto ---------- */
  function initAcordeones() {
    var items = document.querySelectorAll('.pp-faq__item');
    if (!items.length) return;

    items.forEach(function (item) {
      var boton = item.querySelector('.pp-faq__boton');
      var panel = item.querySelector('.pp-faq__panel');
      if (!boton || !panel) return;

      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('pp-abierto');
        var grupo = item.closest('[data-pp-acordeon]');

        if (grupo && grupo.getAttribute('data-pp-acordeon') === 'unico' && !abierto) {
          grupo.querySelectorAll('.pp-faq__item.pp-abierto').forEach(function (otro) {
            otro.classList.remove('pp-abierto');
            var otroPanel = otro.querySelector('.pp-faq__panel');
            var otroBoton = otro.querySelector('.pp-faq__boton');
            if (otroPanel) otroPanel.style.height = '0px';
            if (otroBoton) otroBoton.setAttribute('aria-expanded', 'false');
          });
        }

        if (abierto) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('pp-abierto');
          boton.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('pp-abierto');
          boton.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function fin(e) {
            if (e.propertyName !== 'height') return;
            if (item.classList.contains('pp-abierto')) panel.style.height = 'auto';
            panel.removeEventListener('transitionend', fin);
          });
        }
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    var galeria = document.querySelector('[data-pp-galeria]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-pp-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-pp-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var src = mini.getAttribute('data-pp-mini');
        var alt = mini.getAttribute('data-pp-alt') || '';
        if (!src) return;
        principal.src = src;
        principal.removeAttribute('srcset');
        principal.alt = alt;
        minis.forEach(function (m) {
          m.classList.remove('pp-activa');
          m.setAttribute('aria-current', 'false');
        });
        mini.classList.add('pp-activa');
        mini.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- Selectores: color + talla + formato -> variante real ---------- */
  // Color, talla y formato son opciones de Shopify. Aquí solo se traduce la
  // combinación elegida al id de variante que viaja en el formulario, que es
  // lo que luego lee el proveedor logístico para saber qué enviar.
  function initVariantes() {
    var form = document.getElementById('pp-form-producto');
    if (!form) return;
    var datos = form.querySelector('[data-pp-variantes]');
    var campoId = form.querySelector('[data-pp-variante-id]');
    if (!datos || !campoId) return;

    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    if (!variantes || !variantes.length) return;

    var sinTalla = variantes.every(function (v) { return v.t == null || v.t === ''; });
    var campoColor = form.querySelector('[data-pp-opcion="c"]');
    var campoTalla = form.querySelector('[data-pp-opcion="t"]');
    var radios = form.querySelectorAll('input[data-pp-opcion="f"]');
    var precioVista = document.querySelector('[data-pp-precio-total]');
    var stickyPrecio = document.querySelector('[data-pp-sticky-precio]');
    var boton = form.querySelector('button[type="submit"]');

    function busca(c, t, f) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        // Productos sin talla o sin formato (mochila): null y '' cuentan igual.
        if (v.c === c && (v.t || '') === (t || '') && (v.f || '') === (f || '')) return v;
      }
      return null;
    }

    // Foto del color elegido en la imagen grande. Funciona aunque aún no se
    // haya elegido talla: basta con que alguna variante de ese color tenga foto.
    var ultimoColor = campoColor ? campoColor.value : null;
    function cambiarFoto() {
      if (!campoColor || campoColor.value === ultimoColor) return;
      ultimoColor = campoColor.value;
      var conFoto = null;
      for (var i = 0; i < variantes.length; i++) {
        if (variantes[i].c === ultimoColor && variantes[i].i) { conFoto = variantes[i]; break; }
      }
      var grande = document.querySelector('[data-pp-galeria-principal]');
      if (!conFoto || !grande) return;
      grande.src = conFoto.i;
      grande.removeAttribute('srcset');
      if (conFoto.a) grande.alt = conFoto.a;
      var minis = document.querySelectorAll('.pp-galeria__mini');
      for (var k = 0; k < minis.length; k++) { minis[k].classList.remove('pp-activa'); minis[k].setAttribute('aria-current', 'false'); }
    }

    function refresca() {
      var c = campoColor ? campoColor.value : variantes[0].c;
      var t = campoTalla ? campoTalla.value : variantes[0].t;
      var elegido = form.querySelector('input[data-pp-opcion="f"]:checked');
      var f = elegido ? elegido.value : variantes[0].f;

      // Sin talla elegida no hay variante: el aviso lo da initAvisoTalla.
      // Si el producto no tiene talla (mochila), se sigue con el color.
      if (!t && !sinTalla) return;

      var v = busca(c, t, f);
      if (!v) return;

      campoId.value = v.id;
      if (precioVista) precioVista.textContent = v.e;
      // Precio de referencia: cada variante lleva el suyo (o ninguno). Si la elegida no tiene, se oculta.
      if (v.k !== undefined) {
        var antesEl = document.querySelector('[data-pp-precio-antes]');
        var rebajaEl = document.querySelector('.pp-info__rebaja');
        var notaEl = document.querySelector('.pp-info__referencia');
        if (antesEl) { antesEl.style.display = v.k ? '' : 'none'; if (v.k) antesEl.textContent = v.k; }
        if (rebajaEl) { rebajaEl.style.display = v.k ? '' : 'none'; if (v.k) rebajaEl.textContent = '-' + v.r + '%'; }
        if (notaEl) notaEl.style.display = v.k ? '' : 'none';
      }
      // Foto de la variante exacta (color + formato), si tiene una propia. Solo en productos con formato (ACE):
      // en el resto la foto la sigue llevando el color, como siempre.
      var grandeV = radios.length ? document.querySelector('[data-pp-galeria-principal]') : null;
      if (v.i && grandeV && grandeV.getAttribute('src') !== v.i) {
        grandeV.src = v.i; grandeV.removeAttribute('srcset'); if (v.a) grandeV.alt = v.a;
      }
      if (stickyPrecio) stickyPrecio.textContent = v.e;
      if (boton && !boton.hasAttribute('data-pp-bloqueado')) boton.disabled = !v.d;
    }

    if (campoColor) campoColor.addEventListener('change', function () { cambiarFoto(); refresca(); });
    if (campoTalla) campoTalla.addEventListener('change', refresca);
    for (var i = 0; i < radios.length; i++) {
      radios[i].addEventListener('change', refresca);
    }
    refresca();
  }

  /* ---------- Barra pegajosa de compra (móvil) ---------- */
  function initSticky() {
    var barra = document.querySelector('[data-pp-sticky]');
    var referencia = document.querySelector('[data-pp-sticky-ref]');
    if (!barra || !referencia) return;

    // Se usa un escucha de scroll y no IntersectionObserver: hay navegadores
    // y vistas previas donde el observador no llega a dispararse nunca, y esta
    // barra es demasiado importante para la conversión como para arriesgarse.
    var pedido = false;

    function comprobar() {
      pedido = false;
      var caja = referencia.getBoundingClientRect();
      // Visible cuando la zona de compra ya ha salido por arriba,
      // o cuando todavía no ha llegado por abajo.
      var fueraDeVista = caja.bottom < 0 || caja.top > window.innerHeight;
      barra.classList.toggle('pp-visible', fueraDeVista);
    }

    function alHacerScroll() {
      if (pedido) return;
      pedido = true;
      window.requestAnimationFrame(comprobar);
    }

    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    comprobar();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores() {
    var comparadores = document.querySelectorAll('[data-pp-comparador]');
    if (!comparadores.length) return;

    comparadores.forEach(function (caja) {
      var control = caja.querySelector('[data-pp-comparador-control]');
      var antes = caja.querySelector('[data-pp-comparador-antes]');
      if (!control || !antes) return;

      function medir() {
        // La imagen de la capa recortada debe conservar el ancho total de la caja
        caja.style.setProperty('--pp-ancho-comparador', caja.clientWidth + 'px');
      }

      function pintar() {
        caja.style.setProperty('--pp-corte', control.value + '%');
      }

      control.addEventListener('input', pintar);
      window.addEventListener('resize', medir);

      medir();
      pintar();
    });
  }

  /* ---------- Aviso claro si falta la talla ---------- */
  function initAvisoTalla() {
    var form = document.getElementById('pp-form-producto');
    if (!form) return;
    var selects = form.querySelectorAll('select[data-pp-talla]');
    if (!selects.length) return;

    // Desactivamos la validación del navegador: su mensaje sale en el idioma
    // del navegador y no se puede estilar. Validamos nosotros, en español.
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('submit', function (e) {
      for (var i = 0; i < selects.length; i++) {
        var s = selects[i];
        if (s.disabled || s.value) continue;
        e.preventDefault();
        var grupo = s.closest('.pp-selector');
        if (grupo) grupo.classList.add('pp-selector--falta');
        s.focus();
        s.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    });

    selects.forEach(function (s) {
      s.addEventListener('change', function () {
        var grupo = s.closest('.pp-selector');
        if (grupo) grupo.classList.remove('pp-selector--falta');
      });
    });
  }

  /* ---------- Ventana de la tabla de tallas ---------- */
  function initTablaTallas() {
    var modal = document.querySelector('[data-pp-modal-tallas]');
    if (!modal) return;

    var abridores = document.querySelectorAll('[data-pp-abrir-tallas]');
    var cerradores = modal.querySelectorAll('[data-pp-cerrar-tallas]');
    if (!abridores.length) return;

    function abrir() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var cerrar = modal.querySelector('.pp-modal__cerrar');
      if (cerrar) cerrar.focus();
    }

    function cerrar() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    abridores.forEach(function (b) { b.addEventListener('click', abrir); });
    cerradores.forEach(function (b) { b.addEventListener('click', cerrar); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) cerrar();
    });
  }

  /* ---------- Carrito lateral ----------
     Con el carrito lateral activo, añadir no recarga la página: se añade por
     detrás y se abre el carrito. Lo usan la ficha y el asistente
     (window.PPCarrito). Si el tema vuelve a "página de carrito", no hace nada
     y el formulario funciona como siempre. */
  var PPCarrito = {
    lateral: function () { return document.querySelector('cart-drawer'); },
    anadir: function (items, disparador) {
      var cajon = PPCarrito.lateral();
      var secciones = cajon && cajon.getSectionsToRender ? cajon.getSectionsToRender().map(function (s) { return s.id; }) : [];
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: secciones, sections_url: window.location.pathname })
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || d.status) throw new Error(d.description || d.message || ppT('no_anadir', 'No se ha podido añadir'));
            return d;
          });
        })
        .then(function (d) {
          if (cajon && d.sections) {
            if (disparador) cajon.setActiveElement(disparador);
            cajon.renderContents(d);
          }
          document.dispatchEvent(new CustomEvent('pp:carrito-actualizado', { detail: d }));
          return d;
        });
    }
  };
  window.PPCarrito = PPCarrito;

  // Venta cruzada del carrito lateral: el bloque lo pinta Liquid dentro del cajón, que se repinta
  // entero al cambiar el carrito, por eso el clic va delegado en el documento.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-pp-cruzada-anadir]') : null;
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    PPCarrito.anadir([{ id: Number(b.getAttribute('data-pp-cruzada-anadir')), quantity: 1 }], b)
      .catch(function () { b.disabled = false; });
  });

  function initCarritoLateral() {
    var form = document.getElementById('pp-form-producto');
    if (!form || form.dataset.ppLateral) return;
    form.dataset.ppLateral = '1';

    form.addEventListener('submit', function (e) {
      if (!PPCarrito.lateral() || !window.fetch) return; // sin carrito lateral: envío normal
      e.preventDefault();

      // Sin talla elegida, el aviso lo pinta initAvisoTalla; aquí no se añade nada.
      var faltaTalla = Array.prototype.some.call(form.querySelectorAll('select[data-pp-talla]'), function (s) {
        return !s.disabled && !s.value;
      });
      if (faltaTalla) return;

      var boton = form.querySelector('button[type="submit"]');
      var id = form.querySelector('[name="id"]');
      var cantidad = form.querySelector('[name="quantity"]');
      if (!id || !id.value || (boton && boton.disabled)) return;

      var aviso = form.querySelector('.pp-form__error');
      if (aviso) aviso.remove();
      var textoBoton = boton ? boton.innerHTML : '';
      if (boton) { boton.disabled = true; boton.setAttribute('aria-busy', 'true'); boton.textContent = ppT('anadiendo', 'Añadiendo…'); }

      PPCarrito.anadir([{ id: Number(id.value), quantity: Number(cantidad ? cantidad.value : 1) || 1 }], boton)
        .catch(function (err) {
          var p = document.createElement('p');
          p.className = 'pp-form__error';
          p.setAttribute('role', 'alert');
          p.textContent = err.message || ppT('no_anadir_reintento', 'No se ha podido añadir. Inténtalo de nuevo.');
          (boton ? boton.parentNode : form).appendChild(p);
        })
        .finally(function () {
          if (boton) { boton.innerHTML = textoBoton; boton.disabled = boton.hasAttribute('data-pp-bloqueado'); boton.removeAttribute('aria-busy'); }
        });
    });
  }

  /* ---------- Arranque ---------- */
  function init() {
    initCarritoLateral();
    initReveals();
    initAcordeones();
    initGaleria();
    initVariantes();
    initSticky();
    initComparadores();
    initTablaTallas();
    initAvisoTalla();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sueltas: hay que re-inicializar.
  document.addEventListener('shopify:section:load', init);
})();
